import { render } from "./EditMaterial.vue?vue&type=template&id=77652665&scoped=true"
import script from "./EditMaterial.vue?vue&type=script&lang=js"
export * from "./EditMaterial.vue?vue&type=script&lang=js"

import "./EditMaterial.vue?vue&type=style&index=0&id=77652665&lang=scss&scoped=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77652665"]])

export default __exports__